export function pageReady() {
    // Define context in that we are allowed to access data
    const chamberOfCommerce = document.getElementById('connection-chamber-of-commerce');

    // Global page-data
    let searchResults = [];
    let pageData = {info: null, company: null};

    document.getElementById('chamber-of-commerce-refresh-button')
        .addEventListener('click', async function () {
            await searchChamberOfCommerce();
        });

    document.getElementById('select_branch_location')
        .addEventListener('change', async function (event) {
            await getCompanyDataFromChamberOfCommerce(event.target.value);
        });

    document.getElementById('select_branch_address')
        .addEventListener('change', async function (event) {
            await replaceInputValues(event.target.value);
        });

    // Get search data from KvK API -> only do request when length is 6 and only numbers have been entered
    async function searchChamberOfCommerce() {
        const input = document.getElementById(chamberOfCommerce.getAttribute('data-listener'));
        if (input.value != null && input.value.length === 8 && onlyNumbers(input.value)) {
            resetPageData(true);
            // Do KvK API request
            await getDataFromApi(`/api/v1/kvk/search/${input.value}`, 'branch_number_error')
                .then(function (response) {
                    searchResults = response['data'];
                    addOptions(
                        document.getElementById('select_branch_location'),
                        response['data'],
                        'name',
                        'Kies een vestiging'
                    );
                });
        }
    }

    // Get company data from KvK API -> Check if value has changed and is not caused by API call
    async function getCompanyDataFromChamberOfCommerce(location_index) {
        if (location_index != null && searchResults[location_index] != null) {
            resetPageData(false);
            // Update selected item to info of page
            pageData['info'] = {
                type : searchResults[location_index]['type'],
                commerce_number : searchResults[location_index]['commerce_number'],
                branch_number : searchResults[location_index]['location_number']
            };
            //  Prepare request url based on type of location
            const api_url = searchResults[location_index]['type'] === 'rechtspersoon' ?
                `/api/v1/kvk/basic-profile/${searchResults[location_index]['commerce_number']}` :
                `/api/v1/kvk/branch-profile/${searchResults[location_index]['location_number']}`;
            // Do KvK API request
            await getDataFromApi(api_url, 'address_error')
                .then(function (response) {
                    pageData['company'] = response['data'];
                    if (response['data']['addresses'] != null) {
                        addOptions(
                            document.getElementById('select_branch_address'),
                            response['data']['addresses'],
                            'full_address',
                            'Kies een adres'
                        );
                    }
                });
        }
    }

    // Once an address has been selected update all found inputs with corresponding data
    function replaceInputValues(address_index) {
        // Check if value has changed and is not caused by API call
        if (address_index != null && pageData['company']['addresses'][address_index] != null) {
            // Get fields that we are allowed to replace
            const repFields = JSON.parse(chamberOfCommerce.getAttribute('data-replace-fields'));
            if (repFields != null && repFields.length >= 1) {
                repFields.forEach( function(field) {
                    // If type is set we need to check which type of input we need to replace
                    if (field['type'] != null && field['type'] === 'select') {
                        Array.from(document.querySelector(`#${field['input']}`).options).forEach(function (option_element) {
                            if (chamberOfCommerce.getAttribute('data-default-country') == null) {
                                if (option_element.text === pageData['company']['addresses'][address_index]['country']) {
                                    document.getElementById(field['input']).value = option_element.value;
                                    $(`#${field['input']}`).change();
                                }
                            } else {
                                if (option_element.text === chamberOfCommerce.getAttribute('data-default-country')) {
                                    document.getElementById(field['input']).value = option_element.value;
                                    $(`#${field['input']}`).change();
                                }
                            }
                        });
                    } else {
                        // Split full address_data to access house-number, add to street_name
                        let houseNumber = parseInt(splitAddressData(pageData['company']['addresses'][address_index]));
                        const splitFields = field['replace'].split(".");

                        let string = 'NaN';
                        switch (splitFields[0]) {
                            case "info":
                                string = pageData['info'][splitFields[1]];
                                break
                            case "address":
                                // Specific logic we need to do for some data
                                if (splitFields[1] === 'street_name') {
                                    string = `${pageData['company']['addresses'][address_index]['street_name']} ${houseNumber}`;
                                } else if (splitFields[1] === 'number') {
                                    string = houseNumber;
                                } else {
                                    string = pageData['company']['addresses'][address_index][splitFields[1]];
                                }
                                break
                            case "company":
                                string = pageData['company'][splitFields[1]];
                                break
                        }

                        let formField = document.getElementById(field['input']);
                        if (formField != null) {
                            formField.value = string;
                        }
                    }
                })
            }
            // Store data in hidden input field
            document.getElementById('commerce_data_new').value = JSON.stringify(pageData);
        }
    }

    async function getDataFromApi(request_url, on_error_show) {
        // Prepare for request by setting some items
        toggleSpinner(true);
        showError(null, on_error_show, false);
        // Start request
        return await axios.get(request_url).then(function (response) {
            toggleSpinner(false);
            if (response['data']['success'] != null && response['data']['success'] === true) {
                return response['data'];
            }
        }).catch(function (error) {
            toggleSpinner(false);
            showError(error, on_error_show, true);
        });
    }

    // Show occurred error in blade, replacing the default text with the
    // server-provided message (eg. "Unauthorized ...") when one is available.
    function showError(error, id, should_display) {
        const error_div = document.getElementById(id);
        if (error_div == null) {
            return;
        }

        if (should_display === true) {
            const textElement = error_div.querySelector('small') ?? error_div;
            if (textElement.dataset.defaultText == null) {
                textElement.dataset.defaultText = textElement.textContent;
            }
            textElement.textContent = error?.response?.data?.message ?? textElement.dataset.defaultText;
        }

        error_div.style.display = should_display === true ? 'block' : 'none';
    }

    // Check if provided CommerceNumber is only numbers before doing request
    function onlyNumbers(str) {
        return /^[0-9]+$/.test(str);
    }

    // Dynamically add and remove items from select-boxes
    function addOptions(selectElement, options, show_key, placeholder = null) {
        // First remove already added elements
        removeOptions(selectElement)
        // Prepare new HTML element
        let html = '';
        // Prepend a placeholder option so nothing is selected until the user picks one
        if (placeholder != null) {
            html = html + `<option value="null">${placeholder}</options>`;
        }
        // Loop through the provided entries
        for (const [key, value] of Object.entries(options)) {
            html = html + `<option value="${key}">${value[show_key]} - ${value['type']}</options>`;
        }
        selectElement.innerHTML = html
    }

    // Remove existing options from select-box
    function removeOptions(selectElement) {
        let i, L = selectElement.options.length - 1;
        for (i = L; i >= 0; i--) {
            selectElement.remove(i);
        }
    }

    // Toggle spinner from disabled / enabled
    function toggleSpinner(toggle) {
        setTimeout(function() {
            document.getElementById('chamber-of-commerce-refresh-button').disabled = toggle === true;
            document.getElementById('commerce_loading_spinner').style.display = toggle === true ? 'block' : 'none';
            document.getElementById('commerce_loading_text').style.display = toggle === true ? 'none' : 'block';
        }, toggle === false ? 800 : 0);
    }

    // Reset page-date to original values if needed
    function resetPageData(full_reset) {
        JSON.parse(chamberOfCommerce.getAttribute('data-replace-fields')).forEach( function(field) {
            document.getElementById(field['input']).value = '';
        });
        document.getElementById('commerce_data_new').value = null;

        if (full_reset === true) {
            removeOptions(document.getElementById('select_branch_location'));
            removeOptions(document.getElementById('select_branch_address'));
            pageData = {info: null, company: null};
            searchResults = [];
        }
    }

    // Split address data into several items
    function splitAddressData(address_data) {
        return address_data['full_address']
            .replace(address_data['city'], '')
            .replace(address_data['postal_code'], '')
            .replace(address_data['street_name'], '')
            .replace(address_data['po_box_number'], '')
    }
}
